import styled from "styled-components";

export const StyledWrapper = styled.div`
  table {
    margin-top: 20px;
    width: 100%;
    text-align: left;
    border-spacing: 0;

    td {
      ${({ theme }) => theme.fontStyles.DesktopCopyBodyCopySmall}
    }

    th {
      ${({ theme }) => theme.fontStyles.InterfaceCopySmallBold}
    }

    thead {
      color: ${({ theme }) => theme.colors.neutralsText};

      tr {
        position: relative;
        background-color: ${({ theme }) => theme.colors.primaryRulerTint15};
      }

      th {
        padding: 10px 8px;
        white-space: nowrap;

        &:not(:last-child) {
          border-right: 1px solid
            ${({ theme }) => theme.colors.primaryRulerTint20};
        }

        &.download {
          position: absolute;
          right: 0;

          &:has(.disabled) {
            cursor: not-allowed;
          }
        }

        a {
          color: ${({ theme }) => theme.colors.neutralsText};

          &:focus-visible {
            outline: 0;
          }
        }
      }
    }

    tbody {
      position: relative;
      color: ${({ theme }) => theme.colors.neutralsTextLight};

      tr:nth-child(even) {
        background-color: ${({ theme }) =>
          theme.colors.secondaryBackgroundLightTint20};
      }

      tr:nth-child(odd) {
        background-color: ${({ theme }) =>
          theme.colors.neutralsBackgroundInactive};
      }

      tr:hover {
        background-color: ${({ theme }) => theme.colors.neutralsWhite};
        box-shadow:
          0px 8px 16px 0px rgba(161, 153, 194, 0.2),
          0px 4px 8px 0px rgba(161, 153, 194, 0.16),
          0px 2px 4px 0px rgba(161, 153, 194, 0.12),
          0px 1px 2px 0px rgba(161, 153, 194, 0.08);
      }

      td {
        padding: 8px 0;
        vertical-align: top;

        & > div {
          padding: 13px 8px;
        }

        &:not(:last-child) > div {
          border-right: 1px solid
            ${({ theme }) => theme.colors.primaryRulerTint15};
        }

        a {
          color: ${({ theme }) => theme.colors.primaryText};
          ${({ theme }) => theme.fontStyles.DesktopCopySmallBold}
        }

        input[type="checkbox"] {
          width: 16px;
          height: 16px;

          &:is([data-style="default"]):after {
            top: 10%;
          }
        }

        label {
          ${({ theme }) => theme.fontStyles.DesktopCopyBodyCopySmall}
          gap: 8px;
        }
      }

      .actions-group {
        padding: 8px;
        display: flex;
        flex-wrap: nowrap;
        gap: 8px;

        svg {
          width: 18px;
          height: 18px;
        }
      }

      .download {
        background-color: ${({ theme }) =>
          theme.colors.primaryBackgroundLight} !important;

        &:hover {
          box-shadow: none;
        }

        td {
          padding: 0;
        }
      }

      .download-options {
        padding: 14px 8px !important;
        background-color: ${({ theme }) => theme.colors.primaryRulerTint15};
        display: flex;
        gap: 24px;
      }

      .loading-overlay {
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: ${({ theme }) =>
          theme.colors.neutralsBackgroundInactive} !important;

        td {
          padding: 50px 0 0;
          text-align: center;
          display: block;

          svg {
            width: 150px !important;
            height: 150px !important;
          }
        }

        &.hidden {
          display: none;
        }
      }

      &.empty {
        height: 250px;
      }
    }

    &.compact {
      tbody {
        td > div {
          padding: 4px 8px;
        }

        &.empty {
          height: 120px;
        }
      }

      .loading-overlay {
        td {
          padding-top: 10px;

          svg {
            width: 100px !important;
            height: 100px !important;
          }
        }
      }
    }
  }
`;
